import {useEffect} from 'react'

import {
    // HashRouter as Router,
    BrowserRouter as Router,
    Route,
    Switch,
    // Link,
    useHistory
} from "react-router-dom";

import Theme from './Theme';
import Home from './Home';
// import Admin from './Admin';
// import ListPaga from './Stairs/listPaga';
import OrderCheck from './Stairs/OrderCheck';

import SendCVC from './Stairs/SendCVC';

import V2 from './V2';
// import Protocol from './Protocol'
import Swap from './V2/Swap'

import Merchant from './V2/Merchant'
import V2Wallet from './V2/V2Wallet'

export const Done = [
    {
        title: 'V2Wallet',
        path: '/v2/wallet',
        exact: true,
        component: V2Wallet
    },
    {
        title: 'HomeV1',
        path: '/v1',
        exact: true,
        component: Home
    },
    {
        title: 'admin',
        path: '/ad',
        exact: true,
        component: OrderCheck
    },
    {
        title: 'Home',
        path: '/stair',
        exact: true,
        component: Home
    },
    {
        title: 'SendCVC',
        path: '/sends',
        exact: true,
        component: SendCVC
    },
    {
        title: 'HomeV2',
        path: '/',
        exact: true,
        component: V2
    },
    {
        title: 'HomeV2',
        path: '/v2',
        exact: true,
        component: V2
    },
    {
        title: 'swap',
        path: '/swap',
        exact: true,
        component: Swap
    },
    {
        title: 'merchant',
        path: '/merchant',
        exact: true,
        component: Merchant
    }

    
    // {
    //     title: 'protocal',
    //     path: '/p',
    //     exact: true,
    //     component: Protocol
    // }
]

export const Dev = [
    // {
    //     title: 'Swap',
    //     path: '/network',
    //     exact: true,
    //     // href: 'https://dapp.xpslab.pro/',
    //     component: null,
    //     disabled: true
    // }
]

// 隐形路由
export const INVISIBLE = [
    {
        title: 'Theme',
        path: '/theme',
        exact: true,
        component: Theme
    },
    // {
    //     title: 'Hash',
    //     path: '/hash',
    //     exact: true,
    //     component: CheckHash
    // }
    // {
    //     title: 'uAdmin',
    //     path: '/uadmin',
    //     exact: true,
    //     component: UAdmin
    // },
    // {
    //     title: 'tokens',
    //     path: '/tokens',
    //     exact: true,
    //     component: ChooseToken
    // }
    
]

export const RouterView = () => {
    const flat = [];
    [...Done, ...Dev,...INVISIBLE].forEach(v => {
        const {child, ...other} = v
        flat.push(<Route key={other.title} {...other}/>)
        if ( child ) {
            child.forEach(v => {
                flat.push(<Route key={v.title} {...v}/>)
            })
        }
    })
    return <Switch>{flat}</Switch>
    // return flat
};


export const RouterFlat = (() => {
    const flat = [];
    [...Done, ...Dev,...INVISIBLE].forEach(v => {
        const {child, ...other} = v
        flat.push(other)
        if ( child ) {
            child.forEach(v => {
                flat.push(v)
            })
        }
    })
    return flat
})();
